import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { Filters } from 'data/filters/filters.types';

export enum FiltersMenuActionsType {
  Delete = 'delete',
  // Edit = 'edit',
  View = 'view'
}

export const newFilters: Filters = {
  id: '',
  fgId: '',
  fId: '',
  type: '',
  value: '',
  prefix: '',
  application: '',
}

export const filtersColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('filterGroup.form.field.fgId'),
    field: 'fgId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'fgid',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('filters.form.field.fId'),
    field: 'fId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'fid',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('filters.form.field.type'),
    field: 'type',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'type',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('filters.form.field.VALUELABEL'),
    field: 'value',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'value',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
  {
    headerName: i18n.t('filters.form.field.prefix'),
    field: 'prefix',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'prefix',
    flex: 1,
    minWidth: 250,
    maxWidth: 250,
  },
];
